module.exports = __webpack_public_path__ + "img/atb-w.9491c26c.png";